import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { common } from '../main/common-sidecar'
import { fi32 } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { l } from '../lib/imports'
import { IStevieText } from './stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { scene } from '../main/scene-sidecar'
import { doClose } from '../ui/uiOpenMap'
import { IButton } from './buttons'
import { buttons } from './buttons-sidecar'

export interface IDialog extends IEntity {
  x: number
  y: number
  w: number
  h: number
  images: Phaser.GameObjects.Image[]
  textTitle: IStevieText
  buttonClose: IButton | null
}

const objs: IDialog[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

let frames = [
  fi32(3, 9, 8),
  fi32(3, 9, 10),
  fi32(3, 9, 11),

  fi32(3, 9, 12),
  fi32(3, 9, 13),
  fi32(3, 9, 14),

  fi32(3, 9, 15),
  fi32(3, 9, 16),
  fi32(3, 9, 17),
]

export function create(
  w: number,
  h: number,
  x: number,
  y: number,
  title: string,
  onClose?: () => void,
): IDialog {
  let id = common.createId()

  let ox = x
  let oy = y

  let images: Phaser.GameObjects.Image[] = []
  let tileSize = 40
  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      let frameNum = 4
      if (j === 0) {
        frameNum = 1
      }
      if (j === h - 1) {
        frameNum = 7
      }
      if (i === 0) {
        frameNum = 3
        if (j === 0) {
          frameNum = 0
        }
        if (j === h - 1) {
          frameNum = 6
        }
      }
      if (i === w - 1) {
        frameNum = 5

        if (j === 0) {
          frameNum = 2
        }
        if (j === h - 1) {
          frameNum = 8
        }
      }
      let image = spriteMap.createImageFromFrameInfo(
        layers.getLayers().ui,
        frames[frameNum],
        ox + i * tileSize,
        oy + j * tileSize,
      )
      images.push(image)
    }
  }
  let ctx = scene.getContext()
  let textTitle = stevieText.create(ctx.font24, x, y)
  stevieText.setText(textTitle, title)
  let buttonClose: IButton | null = null
  if (onClose) {
    buttonClose = buttons.create(
      layers.getLayers().ui,
      x + w * tileSize - 72,
      y - 8,
      'X',
      () => {
        onClose()
      },
      buttons.closeFrames,
    )
  }

  let obj: IDialog = {
    eType: 'dialog',
    id,
    x,
    y,
    w: w,
    h: h,
    images,
    textTitle,
    isDead: false,
    buttonClose,
  }
  objs.push(obj)
  return obj
}

export function updateAll() {
  let scene = common.getPhaserScene()
  objs.forEach((c) => {})
}

export function setVisible(obj: IDialog, visible: boolean) {
  l.forEach(obj.images, (c) => {
    c.visible = visible
  })
  stevieText.setVisible(obj.textTitle, visible)
  if (obj.buttonClose) {
    buttons.setVisible(obj.buttonClose, visible)
  }
}
